module.exports = __webpack_public_path__ + "static/Cel1_mobile-f6ec029dca68af67efe831d7806f0c27.mp4";